require('intersection-observer')

let targets;
const stickyObserverOptions = {
 rootMargin: '0px',
 threshold: 1
};
const stickyObserverCallback = (entries, stickyObserver) => {
  // const scrollPos = window.app.$window.scrollTop()
  entries.forEach(entry => {
    /*
    if (entry.isIntersecting) {
      console.log('Enter')
      return
    }
    */
    let eventName = ''
    //scrollPos > entry.boundingClientRect.top
    if (entry.boundingClientRect.top > 0 && entry.isIntersecting) {
     eventName = entry.target.getAttribute('data-iocallback-eventbelow')
    }
    if (entry.boundingClientRect.top < 0) {
     eventName = entry.target.getAttribute('data-iocallback-eventabove')
    }
    if (eventName) {
     window.app.triggerEvent(eventName, entry)
    }
  })
}

// https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/IntersectionObserver
// https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/observe
// https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/unobserve
// https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver/disconnect
const stickyObserver = new IntersectionObserver(stickyObserverCallback, stickyObserverOptions);

const init = function() {
  targets = document.querySelectorAll("[data-iocallback]");
  if (targets.length) {
    targets.forEach(target => stickyObserver.observe(target));
  }
}

const destroy = function() {
  if (targets.length) {
    targets.forEach(target => stickyObserver.unobserve(target));
  }
}

export default {init, destroy}
